import { memo } from 'react';

import CalendarIconSVG from '@/assets/calendar-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ICalendarIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={CalendarIconSVG} {...props} />;

export const CalendarIcon = memo(ICalendarIcon) as typeof ICalendarIcon;
